import React, { antdUI, useEffect, useState } from 'react';
import './index.scss'
import { allCustomItemDataTree } from '@/data/replacingAnalogData.js'
import { useI18n } from '@/i18n';

const uuPrice = {}
const itemSortingData = [
    {
        "label": "隐秘",
        "value": "Rarity_Ancient_Weapon",
        "color": "#EB4B4B"
    },
    {
        "label": "保密",
        "value": "Rarity_Legendary_Weapon",
        "color": "#D32CE6"
    },
    {
        "label": "受限",
        "value": "Rarity_Mythical_Weapon",
        "color": "#8847FF"
    },
    {
        "label": "军规级",
        "value": "Rarity_Rare_Weapon",
        "color": "#4B69FF"
    },
    {
        "label": "工业级",
        "value": "Rarity_Uncommon_Weapon",
        "color": "#5E98D9"
    },
    {
        "label": "消费级",
        "value": "Rarity_Common_Weapon",
        "color": "#B0C3D9"
    }
]
const navData = [
    { title: '武器箱收藏品', val: 2 },
    { title: '地图收藏品', val: 1 }
]
const valuesPrice = Object.values(uuPrice)

function FormulaContainsItems({ showOp: { show, setShow }, boxValue }) {
    const { t, language } = useI18n();
    const [ targetBoxData, setTargetBoxData ] = useState()
    const [ box_value, setBoxValue ] = useState(boxValue)
    const [ navCur, setNavCur ] = useState(2)
    let allPrice = 0
    allCustomItemDataTree.filter(_ => _.type === navCur).forEach(_ => {
        if (uuPrice?.[_.en_name]?.price) {
            allPrice = parseFloat((Number(allPrice) + Number(uuPrice?.[_.en_name]?.price) * 20).toFixed(2))
        }
    })
    const { Collapse } = antdUI, { Panel } = Collapse;
    useEffect(_ => {
        const target = allCustomItemDataTree.filter(_ => _.box_value === box_value)[0]
        const sortedItems = target["头奖"].map((item, index) => {
            const priceList = valuesPrice.filter(_ => {
                const _HashName = _.market_hash_name.replace(/ \(.+?\)$/, '');
                const _ItemName = item.hash_name;
                
                const isNotSouvenir = ! _.market_hash_name.match("Souvenir");
                const isMatchingName = _HashName === _ItemName ||
                    _HashName === _ItemName.replace("★ ", '★ StatTrak™ ') ||
                    _HashName === "StatTrak™ " + _ItemName;
                
                return isNotSouvenir && isMatchingName;
            }).map(item => Number(item.price)).filter(item => item > 0);
            
            // 获取最小值
            const minPrice = Math.min(...priceList);
            const maxPrice = Math.max(...priceList);
            
            return { ...item, minPrice, maxPrice, priceList }; // 将 minPrice 添加到返回的对象中
        });
        
        // 根据 minPrice 对数组进行排序，从高到低
        target["头奖"] = sortedItems.sort((a, b) => b.maxPrice - a.maxPrice);
        setTargetBoxData(target)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ box_value ])
    return (
        <antdUI.Modal title={ t('包含物品') } visible={ show } footer={ null } maskClosable={ false }
                      width="700px" destroyOnClose={ true } onCancel={ _ => setShow(false) }>
            <div className="formula-contains-items">
                {
                    targetBoxData ? <div className="box-de">
                        <div className="title flex ait">
                            <div className="img-box"><img onLoad={ e => e.target.style.opacity = 1 }
                                                          src={ targetBoxData.cover } alt=""/></div>
                            <div className="name">
                                <h2>{ language === 'en-US' ? targetBoxData.en_name : targetBoxData.name }</h2>
                                <p>{ targetBoxData.en_name }</p>
                                <h3 style={ { color: "rgb(255, 148, 27)" } }>{ t('价格：') } { uuPrice?.[targetBoxData.en_name]?.price }</h3>
                            </div>
                            <antdUI.Button className="btn" type="primary" onClick={ () => setBoxValue('') }>{ t('收藏品总览') }
                            </antdUI.Button>
                        </div>
                        <p className="info-text">{ t('此武器箱包含以下物品') }</p>
                        <div className="item-contains">
                            <div className="item-list-box">
                                <Collapse>
                                    <Panel header={ <h3 className="title" style={ {
                                        padding: 0,
                                        margin: 0,
                                        background: "linear-gradient(rgb(246, 236, 179) 0%, rgb(237, 221, 168) 100%)"
                                    } }>
                                        <img style={ { width: "100px", opacity: 1 } }
                                             src="https://g.fp.ps.netease.com/market/file/641c063ed99519519ef538d9ogzOGUgR04"
                                             alt=""/>
                                        ({ targetBoxData?.头奖?.length })
                                    </h3> } key={ "头奖" }>
                                        { targetBoxData.头奖 && targetBoxData.头奖.map((item, index) => {
                                            const { priceList, maxPrice, minPrice } = item;
                                            return (
                                                <div key={ item.itemid } style={ { border: index === 0 ? 'none' : "" } }
                                                     className="item-box flex ait">
                                                    <div className="img-box">
                                                        <img onLoad={ e => e.target.style.opacity = 1 }
                                                             src={ item.cover }
                                                             alt=""/>
                                                    </div>
                                                    <div className="name">
                                                        <h1 style={ { margin: 0 } }>{ item.name } ({ priceList.length })</h1>
                                                        <h3 style={ {
                                                            color: "rgb(255, 148, 27)",
                                                        } }>{ t('价格区间：') }
                                                            [ { `${ minPrice } ~ ${ maxPrice }` } ]</h3>
                                                        <h5 style={ {
                                                            color: "rgb(244, 208, 63)",
                                                        } }>{ t('价格：') } { priceList.sort((a, b) => a - b).join(" - ") }</h5>
                                                    </div>
                                                </div>
                                            )
                                        }) }
                                    </Panel>
                                </Collapse>
                            
                            </div>
                            { (() => {
                                let listData = [], li;
                                itemSortingData.forEach(_ => {
                                    li = targetBoxData.children.filter(item => {
                                        if (item.en_rarity === _.value) {
                                            item.color = _.color
                                            return item
                                        } else {
                                            return null
                                        }
                                    })
                                    li[0] && (listData.push(li))
                                })
                                return listData.map((list, idx) => {
                                    return (<div className="item-list-box" key={ idx }>
                                        <Collapse>
                                            <Panel header={ <h3 className="title"
                                                                style={ { backgroundColor: list[0].color, margin: 0 } }>
                                                { language === 'en-US' ? t(list[0].rarity) : list[0].rarity }({ list.length })
                                            </h3> } key={ "头奖" }>
                                                { list.map((item, index) => {
                                                    const priceList = valuesPrice
                                                    .filter(_ => {
                                                        const _HashName = _.market_hash_name.replace(/ \(.+?\)$/, '');
                                                        const _ItemName = item.hash_name;
                                                        
                                                        const isNotSouvenir = ! _.market_hash_name.match("Souvenir");
                                                        const isMatchingName = _HashName === _ItemName ||
                                                            _HashName === _ItemName.replace("★ ", '★ StatTrak™ ') ||
                                                            _HashName === "StatTrak™ " + _ItemName;
                                                        
                                                        return isNotSouvenir && isMatchingName;
                                                    })
                                                    .map(item => Number(item.price));
                                                    const _priceList = priceList.filter(item => item > 0)
                                                    return (<div key={ item.itemid }
                                                                 style={ { border: index === 0 ? 'none' : "" } }
                                                                 className="item-box flex ait">
                                                        <div className="img-box">
                                                            <img onLoad={ e => e.target.style.opacity = 1 }
                                                                 src={ item.cover }
                                                                 alt=""/>
                                                        </div>
                                                        <div className="name">
                                                            <h2 style={ { margin: 0 } }>{ item.name } ({ _priceList.length })</h2>
                                                            <h3 style={ {
                                                                color: "rgb(255, 148, 27)",
                                                            } }>{ t('价格区间：') }
                                                                [ { `${ Math.min(..._priceList) } ~ ${ Math.max(..._priceList) }` } ]</h3>
                                                            <h5 style={ {
                                                                color: "rgb(244, 208, 63)",
                                                            } }>{ t('价格：') } { _priceList.sort((a, b) => a - b).join(" - ") }</h5>
                                                        </div>
                                                    </div>)
                                                }) }
                                            </Panel>
                                        </Collapse>
                                    </div>)
                                })
                            })() }
                        </div>
                    </div> : <>
                        <div className="box">
                            <div className="nav">
                                { navData.map(_ => {
                                    const cls = navCur === _.val ? 'nav-item current' : 'nav-item'
                                    return <button onClick={ () => setNavCur(_.val) } key={ _.val }
                                                   className={ cls }>{ t(_.title) }</button>
                                }) }
                            </div>
                            <p>{ allPrice }</p>
                            <div className="box-list-container">
                                {
                                    allCustomItemDataTree.filter(_ => _.type === navCur).map(_ => {
                                        return <div onClick={ () => setBoxValue(_.box_value) } key={ _.box_value }
                                                    className="box-item">
                                            <div className="box-img">
                                                <img onLoad={ e => e.target.style.opacity = 1 } src={ _.cover } alt=""/>
                                            </div>
                                            <div className="box-nam">
                                                <h3>{ language === 'en-US' ? _.en_name : _.name }</h3>
                                                <p className="text-ov1">{ _.en_name }</p>
                                                <p>{ _.box_value }</p>
                                                <h4 style={ { color: "rgb(255, 148, 27)" } }>价格: { uuPrice?.[_.en_name]?.price }</h4>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </>
                }
            </div>
        </antdUI.Modal>
    )
}

export default FormulaContainsItems;
